import FJVersionConfig from '../FJVersionConfig';
import { LOCAL, RELEASE } from '../../constants/FJEvnConstant';
const environment = import.meta.env.MODE;

export default {
    stylePath: environment === LOCAL ? `/public/style/` : `/app/ai-tools/style/`,
    originalImageKey: 'ai/input/face-swap/',
    resultImageKey: 'ai/export/face-swap/',
    historyListType: 11,
    freeLimitType: 'face-swap',
    currentMenuName: 'ai-face-swap',
    thoseOriginImagesPath:
        environment === LOCAL
            ? `/public/img/faceSwap/origin/`
            : environment === RELEASE
              ? `https://resource.flexclip.com/app/ai-tools/img/faceSwap/origin/`
              : `/app/ai-tools/img/faceSwap/origin/`,
    thoseTargetImagesPath:
        environment === LOCAL
            ? `/public/img/faceSwap/target/`
            : environment === RELEASE
              ? `https://resource.flexclip.com/app/ai-tools/img/faceSwap/target/`
              : `/app/ai-tools/img/faceSwap/target/`,

    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/faceSwap/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/faceSwap/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/faceSwap/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/faceSwap/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxTitle: 'swap-faces-seamlessly-using-ai',
    notImageBoxDesc: 'explore-endless-possibilities-and-fun-of-face-swapping',
};
